/**
 * InvitationInvalid Component
 *
 * Story 5.7: Invitation Acceptance Flow
 * Displayed when invitation token is invalid or malformed.
 */

import type { JSX } from 'react';
import { Link } from 'react-router-dom';
import { XCircleIcon } from '@heroicons/react/24/outline';
import { Button, Card, CardBody } from '@heroui/react';

export function InvitationInvalid(): JSX.Element {
  return (
    <div className="flex min-h-[60vh] items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardBody className="items-center gap-4 py-8 text-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-danger">
            <XCircleIcon className="h-12 w-12" />
          </div>

          <h1 className="text-2xl font-semibold">Invalid Invitation</h1>

          <p>This invitation link is invalid or has been corrupted.</p>

          <p className="text-sm text-muted">
            Please check the link or contact the organization administrator for a new invitation.
          </p>

          <Button as={Link} to="/" color="primary" className="mt-4">
            Go to Home
          </Button>
        </CardBody>
      </Card>
    </div>
  );
}
